import { config } from './config.js';

// Thin wrapper around @clerk/clerk-js. Loaded lazily so that builds without
// a key (offline / pre-launch) don't fail. When no key is configured the app
// runs in "anonymous" mode — IDB-only, no cloud sync.

let clerk = null;
let loadPromise = null;
const listeners = new Set();

export function isConfigured() {
  return Boolean(config.clerkKey);
}

export async function initAuth() {
  if (!isConfigured()) return null;
  if (loadPromise) return loadPromise;
  loadPromise = (async () => {
    const mod = await import('@clerk/clerk-js');
    const Clerk = mod.Clerk || mod.default;
    clerk = new Clerk(config.clerkKey);
    await clerk.load({ signInUrl: undefined });
    clerk.addListener(() => listeners.forEach((cb) => cb(getUser())));
    return clerk;
  })();
  return loadPromise;
}

export function getUser() {
  return clerk?.user || null;
}

export async function getToken() {
  const session = clerk?.session;
  if (!session) return null;
  try {
    return await session.getToken();
  } catch {
    return null;
  }
}

export function signIn() {
  if (!clerk) return;
  clerk.openSignIn({});
}

export function signOut() {
  if (!clerk) return;
  clerk.signOut();
}

export function onAuthChange(cb) {
  listeners.add(cb);
  return () => listeners.delete(cb);
}
